import React from 'react';

import { cn } from 'revibe-ui';
import { useFormikContext } from 'formik';
import { useTranslation } from 'i18n/hooks';
import { FormControl } from 'revibe-ui';

import { useMediaQuery } from 'modules/common/hooks';
import { ITEM_FILTERS } from 'modules/item/utils/itemFilter';

import { CategoryFilter } from './CategoryFilter';
import { MarketplaceAPI } from 'revibe-api';

export const SexFilter = () => {
  const { tu } = useTranslation('listing.filters');
  const { isMobile } = useMediaQuery();
  const { values, setFieldValue, handleSubmit } =
    useFormikContext<MarketplaceAPI.ItemFilters>();

  return (
    <div className="w-full">
      <FormControl label={tu('category')}>
        <div className="mb-2 grid grid-cols-2 gap-2">
          {['male', 'female'].map((sex) => (
            <p
              key={sex}
              className={cn(
                'cursor-pointer border bg-gray-50 p-2 text-center text-xs font-light uppercase hover:text-black',
                values[ITEM_FILTERS.SEX] === sex
                  ? 'border-black text-black hover:border-black'
                  : 'border-gray-200 text-gray-400 hover:border-black'
              )}
              onClick={() => {
                setFieldValue(ITEM_FILTERS.SEX, sex);
                !isMobile && handleSubmit();
              }}
            >
              {tu(sex, 'common')}
            </p>
          ))}
        </div>
        <CategoryFilter />
      </FormControl>
    </div>
  );
};
